export const CLASS_NAMES = {
  container: '-mb-6',
  link: 'mb-6',
};
